import { createSlice } from '@reduxjs/toolkit';

import {getPriceNegotiationDetails,updatePocDetails, updatePriceNegotiationDetails, saveManualPriceNegoEntry} from '../../apis';

export const PriceNegotiation = createSlice({

    name: 'priceNegotiation',
    initialState: {
        loading: false,
        error: '' ,
        priceNegotiationData: [],
        updatePocDetailsSuccess: false,
        updateNegotiatiablesSuccess: false,
        saveManualEntrySuccess: false
    },
    reducers: {
        clearError: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clearUpdatePocDetailsSuccess: (state, action) => {
            return {
                ...state,
                updatePocDetailsSuccess: action.payload
            }
        },
        clearUpdatePriceSuccess: (state, action) => {
            return {
                ...state,
                updateNegotiatiablesSuccess: action.payload
            }
        },
        clearSaveManualPriceNegoEntry: (state, action) => {
            return {
                ...state,
                saveManualEntrySuccess: action.payload
            }
        }
    },

    extraReducers: (builder) => {
        builder.addCase(getPriceNegotiationDetails.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getPriceNegotiationDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.priceNegotiationData = action.payload.data;
        })
        builder.addCase(getPriceNegotiationDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
        })
        builder.addCase(updatePocDetails.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(updatePocDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.updatePocDetailsSuccess = true;
        })
        builder.addCase(updatePocDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
        })
        builder.addCase(updatePriceNegotiationDetails.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(updatePriceNegotiationDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.updateNegotiatiablesSuccess = true;
        })
        builder.addCase(updatePriceNegotiationDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
        })
        builder.addCase(saveManualPriceNegoEntry.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(saveManualPriceNegoEntry.fulfilled, (state, action) => {
            state.loading = false;
            state.saveManualEntrySuccess = true;
        })
        builder.addCase(saveManualPriceNegoEntry.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
        })
    }
})

export const {clearError, clearUpdatePocDetailsSuccess, clearUpdatePriceSuccess, clearSaveManualPriceNegoEntry} = PriceNegotiation.actions
export default PriceNegotiation.reducer